/**
 * orga-app-api - api-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ScannerLicense { 
    is_valid?: boolean;
    is_test?: boolean;
    license_key?: string;
    mandant_id?: string;
}

